import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const uploadVideoChunk = (currentChunk, uploadChunkObject, data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPLOAD_VIDEO_CHUNK(currentChunk, uploadChunkObject),
    data
  );
};

export default uploadVideoChunk;
